import Mock from 'mockjs';

const LoginUsers = [
    {
        id: 1,
        username: 'admin',
        password: '123456',
        avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png',
        name: '张某某',
        token: '1231'
    }
];


const Users = [];

for (let i = 0; i < 86; i++) {
    Users.push(Mock.mock({
        id: Mock.Random.guid(),
        head_url: Mock.Random.image('40x40'),
        pwd: Mock.Random.word(6, 10),
        user_name: Mock.Random.cname(),
        nickname: Mock.Random.cname(),
        realname: Mock.Random.cname(),
        phone_num: Mock.Random.word(6, 10),
        star_level: Mock.Random.integer(0, 5),
        is_vip: Mock.Random.integer(0, 1),
        addr: Mock.mock('@county(true)'),
        'age|18-60': 1,
        vip_expire_time: Mock.Random.datetime(),
        birthday: Mock.Random.date(),
        vip_status: Mock.Random.integer(0, 2),
        status: Mock.Random.boolean(0, 1),
        sex: Mock.Random.integer(0, 1),
        is_allow_enroll: Mock.Random.boolean(0, 1),
        resume: '@cparagraph(2)'
    }));
}


const Users_admin = [];

for (let i = 0; i < 86; i++) {
    Users_admin.push(Mock.mock({
        id: Mock.Random.guid(),
        user_name: Mock.Random.cname(),
        pwd: Mock.Random.word(6, 10),
        full_name: Mock.Random.cname(),
        roles: Mock.Random.integer(0, 2),
        status: Mock.Random.boolean(0, 1),
        sex: Mock.Random.integer(0, 1)
    }));
}



const Users_vip = [];

for (let i = 0; i < 86; i++) {
    Users_vip.push(Mock.mock({
        id: Mock.Random.guid(),
        head_url: Mock.Random.image('40x40'),
        pwd: Mock.Random.word(6, 10),
        user_name: Mock.Random.cname(),
        nickname: Mock.Random.cname(),
        realname: Mock.Random.cname(),
        phone_num: Mock.Random.integer(13481059267, 14481059267),
        star_level: Mock.Random.integer(0, 5),
        addr: Mock.mock('@county(true)'),
        'age|18-60': 1,
        vip_expire_time: Mock.Random.datetime(),
        birthday: Mock.Random.date(),
        vip_status: Mock.Random.integer(0, 2),
        status: Mock.Random.boolean(0, 1),
        sex: Mock.Random.integer(0, 1),
        is_allow_enroll: Mock.Random.boolean(0, 1),
        resume: Mock.Random.cparagraph(2)
    }));
}



const Vip_chongzhi = [];

for (let i = 0; i < 86; i++) {
    Vip_chongzhi.push(Mock.mock({
        id: Mock.Random.guid(),
        head_url: Mock.Random.image('40x40'),
        nickname: Mock.Random.cname(),
        amounts: Mock.Random.integer(),
        day_num: Mock.Random.integer(),
        create_time: Mock.Random.datetime(),
        expire_time: Mock.Random.datetime(),
        resume: Mock.Random.cparagraph(2)
    }));
}


const Vip_Product = [];

for (let i = 0; i < 86; i++) {
    Vip_Product.push(Mock.mock({
        id: Mock.Random.guid(),
        product_name: Mock.Random.character("年卡","半年卡","月卡"),
        day_num: Mock.Random.integer(30,365),
        amounts: Mock.Random.integer(30,365),
        orig_price: Mock.Random.integer(30,365),
        status: Mock.Random.boolean(0, 1)
    }));
}

export { LoginUsers, Users, Users_admin, Users_vip, Vip_chongzhi, Vip_Product };


// WEBPACK FOOTER //
// ./src/mock/data/user.js